/**
 * ماژول چاپروم در فرانت‌اند — فقط وقتی بک‌اند ماژول chaproom را برای شرکت فعال کرده باشد استفاده می‌شود.
 * فعال بودن را با hasCompanyFeature از company/features بررسی کنید.
 */

export const CHAPROOM_MODULE = 'chaproom';

/** قابلیت‌هایی که با فعال بودن ماژول چاپروم روشن می‌شوند */
export const CHAPROOM_FEATURES = [
  /** باکس اطلاعات پستی سفارش در مشاهده وظیفه */
  'task.postalInfoBox',
  /** دکمه بررسی وضعیت کنسل سفارش در مشاهده وظیفه */
  'task.chaproomStatusCheck',
  /** مدال کد رهگیری / نحوه ارسال هنگام انتقال به «بسته بندی و ارسال» */
  'task.chaproomPackagingShipping',
  /** چند مسئول هم‌زمان روی یک وظیفه (بقیه شرکت‌ها: یک مسئول + همکاران) */
  'task.multipleAssignees',
  /** جابه‌جایی آزاد بین ستون‌های خط تولید (بدون ماشین حالت «بررسی ← تأیید») */
  'task.freeStatusFlow',
  /** دو برد جدا: «سفارش‌ها» (خط تولید) و «کارهای عمومی» */
  'task.orderBoard',
  /** ثبت مشکل چاپ توسط پشتیبانی؛ سفارش با اولویت بالا در ستون «سفارش‌های مشکل‌دار» (صف چاپ مجدد) می‌ماند */
  'task.chaproomOrderProblems',
  /** گزارش نهایی اپراتور چاپ (بهره‌وری) */
  'task.chaproomOperatorReport',
];

/** محدوده ستون‌های خط تولید سفارش‌ها (مقدار scope در taskboard_columns) */
export const CHAPROOM_ORDERS_BOARD = 'orders';

/** شماره سفارش چاپروم از order_fields (بدون #) */
export const extractChaproomOrderId = (task) => {
  const cf = task?.custom_fields;
  const orderFields = Array.isArray(cf?.order_fields)
    ? cf.order_fields
    : Array.isArray(task?.order_fields)
      ? task.order_fields
      : [];

  const orderField = orderFields.find(
    (f) => String(f?.name || '').trim().toLowerCase() === 'order_id',
  );
  const raw = orderField?.value;
  if (raw != null && String(raw).trim()) {
    const digits = String(raw).replace(/[^\d]/g, '');
    if (digits) return digits;
  }
  return null;
};

export const isChaproomOrderCanceled = (res) => {
  const v = res?.is_canceled ?? res?.data?.is_canceled ?? res?.is_cancelled ?? res?.data?.is_cancelled;
  return v === true || v === 1 || v === '1' || String(v).toLowerCase() === 'true';
};

/** نرمال‌سازی نام ستون کانبان برای مقایسه فارسی */
export const normalizeFaColumnName = (value) =>
  String(value || '')
    .replace(/\u200c/g, '')
    .replace(/\s+/g, ' ')
    .trim();

/** ستون «بسته بندی و ارسال» چاپروم */
export const isChaproomPackagingColumn = (columnOrName) => {
  const raw =
    typeof columnOrName === 'string'
      ? columnOrName
      : columnOrName?.column_name || columnOrName?.name || '';
  return normalizeFaColumnName(raw) === normalizeFaColumnName('بسته بندی و ارسال');
};

/** پارامترهای ارسال در change-status */
export const isChaproomShippingExtra = (extra) =>
  extra != null &&
  typeof extra === 'object' &&
  !Array.isArray(extra) &&
  ('trackingCode' in extra || 'postageMethod' in extra);

export const CHAPROOM_POSTAGE_METHOD_OPTIONS = [
  { value: 'پست ویژه', label: 'پست ویژه' },
  { value: 'ارسال با پیک', label: 'ارسال با پیک' },
];

/** ستون ورودی «سفارش‌های مشکل‌دار» (slug در taskboard_columns) */
export const CHAPROOM_PROBLEM_COLUMN_SLUG = 'order_problem';

export const isChaproomProblemColumn = (column) => column?.slug === CHAPROOM_PROBLEM_COLUMN_SLUG;

/** علت‌های چاپ اشتباه (کلیدها با بک‌اند یکی است) */
export const CHAPROOM_PROBLEM_CAUSES = [
  { value: 'incomplete_print', label: 'چاپ ناقص' },
  { value: 'wrong_size', label: 'سایز نامناسب' },
  { value: 'no_print_settings', label: 'عدم تنظیمات چاپ' },
  { value: 'print_color_issue', label: 'مشکل چاپ و رنگ چاپ' },
  { value: 'binding_issue', label: 'مشکل صحافی' },
];
